import styled from "styled-components";

export const InputContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
`;

export const EdgeInput = styled.input`
  width: 150px;
  height: 34px;
  outline: none;
  border: 0.941243px solid #d4d6da;
  border-radius: 5.64746px;

  font-size: 12px;
  padding-left: 10px;

  &:hover {
    border: 1px solid rgba(0, 0, 0, 0.87);
  }

  &:focus {
    border: 1px solid #40e5a0;
  }
`;

export const Label = styled.span`
  color: #42464c;
  font-family: Sora;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: left;
  margin-left: 9px;
`;
